<template>
    <div>

        <router-link :to="{ name: 'Home' }" class="text-decoration-none">
            <img src="../../../src/assets/Logo_RayiQ.svg" class="p-3 logo" />
        </router-link>



        <ul class="nav-items">

            <li>
                <router-link :to="{ name: 'DashboardHome' }" class="text-decoration-none"><b-icon-grid-fill /> {{ $t('dashboardHome.dashboard') }}</router-link>
            </li>
            <li>
                <router-link :to="{ name: 'DiscardedItems' }" class="text-decoration-none"><b-icon-trash-fill /> {{ $t('privateMenu.discardedItems') }} <span v-if="$store.state.lstDiscardedAprons.length > 0">({{$store.state.lstDiscardedAprons.length}})</span><span v-else>({{$store.state.intDiscardedItems}})</span></router-link>
            </li>
            <li>
                <router-link :to="{ name: 'Settings' }" class="text-decoration-none"><b-icon-gear-fill /> {{ $t('apronShortlist.settings') }}</router-link>
            </li>
            <li>
                <router-link :to="{ name: 'ProductSelector', params: { category: 2 } }" :class="{'router-link-exact-active': childRouteActive('/LAA/Configurator')}"><b-icon-shop /> {{ $t('configurator.configurator') }}</router-link>
            </li>
            <!--<li>
            <router-link :to="{ name: 'Home' }" class="text-decoration-none"> <b-icon-arrow-left />Back to landingspage</router-link>
        </li>-->
            <li v-if="isLoggedIn">
                <a v-on:click="AttemptLogOut()"> <b-icon-box-arrow-left /> {{ $t('privateMenu.logOut') }}</a>
            </li>

        </ul>
        <div class="language-selection border-top">

            <div v-if="!showLang"  class="language-selection__button position-relative">
                <a v-on:click="showLang =  !showLang" href="#"> <b-icon-globe />  Select Language</a>
            </div>

            <div  v-show="showLang" class="language-selection__select ">
                <locale-switcher v-on:is-changed=" showLang = !showLang;"></locale-switcher>
            </div>

        </div>



    </div>
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import LocaleSwitcher from "@/public/components/LocaleSwitcher.vue";

    export default {
        name: "PrivateMenu",
        components: {
            LocaleSwitcher
        },
        data() {
            return {
                isAdmin: false,
                showLang: false,
            }
        },
        computed: {
            
            ... mapState([
            'isLoggedIn'
        ])
        },
        mounted: function () {
			this.$store.dispatch('UPDATE_IsLoggedIn')
        },
        methods: {
            AttemptLogOut() {

                axios({
                    method: 'post',
                    url: '/account/logout',
                })
                    .then(() => {
                        this.$store.commit('SET_isLoggedIn', false);
                        this.$router.push({ name: 'Home' })
                    })
                    .catch((error) => {
                        alert(error);
                    });
            },
            childRouteActive(input) {
                const paths = Array.isArray(input) ? input : [input]
                return paths.some(path => {
                    return this.$route.path.indexOf(path) === 0 // current path starts with this path string
                })
            },
            
        },
    }
</script>